// Ported from horizontal-actions-dashboard/frontend/src/components/StateViews.tsx,
// translated to MUI.

import { Box, CircularProgress, Typography, Alert, Button, Stack } from '@mui/material';
import { ApiError } from '../../api/horizontalActionsApi';

export function TerminalsLoadingState({ label = 'Loading dashboard data…' }: { label?: string }) {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 6 }} role="status" aria-live="polite">
      <CircularProgress size={32} />
      <Typography variant="body2" sx={{ color: '#5a6b7c' }}>
        {label}
      </Typography>
    </Stack>
  );
}

export function TerminalsEmptyState({ title, description }: { title: string; description?: string }) {
  return (
    <Box sx={{ py: 6, textAlign: 'center' }} role="status">
      <Typography variant="h6">{title}</Typography>
      {description && (
        <Typography variant="body2" sx={{ color: '#5a6b7c', mt: 1 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}

export function TerminalsErrorState({ error, onRetry }: { error: ApiError | Error; onRetry?: () => void }) {
  const kind = error instanceof ApiError ? error.kind : 'unknown';
  const titles: Record<string, string> = {
    backend_unavailable: 'Backend is unavailable',
    workbook_missing: 'Workbook not found',
    malformed_workbook: 'Workbook could not be parsed',
    not_found: 'Not found',
    unknown: 'Something went wrong',
  };
  const descriptions: Record<string, string> = {
    backend_unavailable: 'Could not reach the API at the configured backend URL. Confirm the backend is running.',
    workbook_missing: 'The backend could not find the HA workbook at the configured path.',
    malformed_workbook: 'The workbook could not be parsed. Check the backend logs for details.',
    not_found: 'The requested resource does not exist.',
    unknown: error.message,
  };
  return (
    <Alert
      severity="error"
      role="alert"
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            Try again
          </Button>
        ) : undefined
      }
      sx={{ my: 2 }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {titles[kind] ?? titles.unknown}
      </Typography>
      <Typography variant="body2">{descriptions[kind] ?? error.message}</Typography>
    </Alert>
  );
}
